import React from "react";
import { Button } from "@mui/material";
import Typewriter from "typewriter-effect";
import bg from "../../assets/img/bg.jpg";
import { Icon } from "@iconify/react";
import githubFilled from "@iconify/icons-ant-design/github-filled";
import linkedinFilled from "@iconify/icons-ant-design/linkedin-filled";

import "./LandingPage.css";
import { useMediaQuery } from "react-responsive";

const LandingPage = () => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const viewCVHandler = () => {
    window.open(
      "https://drive.google.com/file/d/1jRs35VpUFXSBPwDTKwo_YGTspI51gQBl/view?usp=sharing"
    );
  };

  return (
    <div id="lp-main-div">
      <img
        style={{ height: isTabletOrMobile ? "90vh" : "" }}
        src={bg}
        id="lp-img"
      />
      <div
        style={{
          width: "fit-content",
          height: "100%",
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          justifyContent: isTabletOrMobile ? "flex-start" : "center",
          marginTop: isTabletOrMobile ? "80px" : "30px",
        }}
      >
        <h1
          style={{
            color: "white",
            paddingLeft: "30px",
            fontSize: isTabletOrMobile ? "70px" : "50px",
            fontFamily: "Tenorite",
          }}
        >
          Hi{" "}
          <Icon
            icon="mdi:hand-wave"
            color="gold"
            style={{ fontSize: "60px", marginBottom: "10px" }}
          />
        </h1>
        <h1
          style={{
            color: "white",
            paddingLeft: "30px",
            fontSize: isTabletOrMobile ? "38px" : "50px",
            fontFamily: "Tenorite",
          }}
        >
          I'm <strong> Thushal TK </strong>
        </h1>
        <h1
          style={
            isTabletOrMobile
              ? { display: "none" }
              : { color: "white", paddingLeft: "30px", fontSize: "80px" }
          }
        >
          <strong>
            <Typewriter
              options={{ loop: true }}
              onInit={(typewriter) => {
                typewriter
                  .typeString("Team Leader")
                  .pauseFor(1000)
                  .deleteAll()
                  .typeString("Full-Stack Developer")
                  .pauseFor(1000)
                  .deleteAll()
                  .typeString("Mobile App Developer")
                  .pauseFor(1000)
                  .deleteAll()
                  .typeString("RPA Developer")
                  .pauseFor(1000)
                  .deleteAll()
                  .typeString("Video Game Developer")
                  .pauseFor(1000)
                  .deleteAll()
                  .typeString("UI/UX Designer")
                  .pauseFor(1000)
                  .deleteAll()
                  .start();
              }}
            />
          </strong>
        </h1>
        <br />
        <Button
          style={{
            width: "fit-content",
            marginLeft: "30px",
            backgroundColor: "#F7DF1E",
            color: "black",
            fontSize: "15px",
            fontWeight: "bold",
            fontFamily: "Tenorite",
          }}
          variant="contained"
          onClick={viewCVHandler}
        >
          View CV
        </Button>
        {isTabletOrMobile ? (
          <>
            <br />
            <br />
          </>
        ) : (
          <br />
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginLeft: "30px",
            marginTop: "30px",
          }}
        >
          <span id="pill">
            <Icon
              icon={githubFilled}
              style={{ fontSize: "30px", color: "black" }}
            />
            <a
              href="https://github.com/thushaltk"
              style={{
                marginBottom: "0",
                marginLeft: "10px",
                color: "black",
                fontSize: isTabletOrMobile ? "15px" : "14px",
                fontWeight: "600",
                fontFamily: "Tenorite",
              }}
            >
              ThushalTK
            </a>
          </span>
          <span id="pill">
            <Icon
              icon="openmoji:artstation"
              style={{ fontSize: "30px", color: "red" }}
            />
            <a
              href="https://www.artstation.com/thuzhaltk"
              style={{
                marginBottom: "0",
                marginLeft: "10px",
                color: "black",
                fontSize: "14px",
                fontWeight: "600",
                fontFamily: "Tenorite",
              }}
            >
              thuzhaltk
            </a>
          </span>
          <span id="pill">
            <Icon
              icon={linkedinFilled}
              style={{
                fontSize: "30px",
                color: "#155BDD",
                borderRadius: "50px",
              }}
            />
            <a
              href="https://www.linkedin.com/in/thushaltk/"
              style={{
                marginBottom: "0",
                marginLeft: "10px",
                color: "black",
                fontSize: "14px",
                fontWeight: "600",
                fontFamily: "Tenorite",
              }}
            >
              ThushalTK
            </a>
          </span>
        </div>
      </div>
      <div style={{ height: isTabletOrMobile ? "90vh" : "100vh" }}></div>
    </div>
  );
};

export default LandingPage;
